// extracted by mini-css-extract-plugin
export default {"size":"info-size__size___Kea8I","infoContainer":"info-size__infoContainer___nF2fA","title":"info-size__title___YPqJf"};